module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-404"
    }
  }, [_c('div', {
    ref: "starsBg",
    attrs: {
      "id": "starsBg"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "notFound"
    }
  }, [_c('h1', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "textContent": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "id": "goBackBtn",
      "label": "Go Back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-431c73c9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404/404.vue
// module id = 3142
// module chunks = 1